module.exports = __webpack_public_path__ + "img/layout-two-icon-17022022.b0934b88.svg";